import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import Link from '@src/components/link';
import PhoneAppointmentModalStore from './store';
import PhoneCodeInput from '../phone-code-input';

const styles = require('./index.less');

/**
 * 弹窗模板, 可以快速套用修改
 */
const PhoneAppointmentModal = ({ store, onClose }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }

  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={cx(styles.phoneAppointmentModalRoot)}>
        <div className="phone-appointment-modal-root">
          <div className="phone-appointment-modal-group-1" data-name="手机预约">
            <div className="phone-appointment-modal-layer-1" />
            <div className="phone-appointment-modal-layer-2" />
            <div className="phone-appointment-modal-group-2" data-name="填写">
              <PhoneCodeInput store={store.phoneCodeInputStore} />
            </div>

            <div className="phone-appointment-modal-group-8" data-name="阅读并同意" onClick={() => store.checkAgree()}>
              <div className="phone-appointment-modal-group-9" data-name="选择框">
                {store.isAgree ? <div className="phone-appointment-modal-layer-13" /> : <div className="phone-appointment-modal-layer-14" />}
              </div>
              <div className="phone-appointment-modal-layer-10">
                已阅读并同意
                <Link
                  href="https://js4.seasungames.cn/p/zt/2025/07/21/privacy/index.html?contentId=snazprh7aww1#/"
                  target="_blank"
                  onClick={e => e.stopPropagation()}
                >
                  《金山网络服务使用协议》
                </Link>、
                <Link
                  href="https://js4.seasungames.cn/p/zt/2025/07/21/privacy/index.html?contentId=snazvjmyopa9#/"
                  target="_blank"
                  onClick={e => e.stopPropagation()}
                >
                  《金山在线隐私权政策》
                </Link>
              </div>
            </div>

            {/* <div className="phone-appointment-modal-group-10" data-name="设备选择">
              {store.deviceList.map(item => (
                <div className="phone-appointment-modal-group-11" key={item.value} data-name={item.label} onClick={() => store.selectDeviceType(item.value)}>
                  {store.deviceType === item.value ? (
                    <div className="phone-appointment-modal-layer-16" />
                  ) : (
                    <div className="phone-appointment-modal-layer-18" />
                  )}
                  {item.label}
                </div>
              ))}
            </div> */}
            <div className="phone-appointment-modal-group-10" data-name="设备选择">
              {store.deviceList.map(item => (
                <div className="phone-appointment-modal-group-11" key={item.value} data-name={item.label} onClick={() => store.selectDeviceType(item.value)}>
                  {store.deviceType.includes(item.value) ? ( // 改为判断数组中是否包含当前值
                    <div className="phone-appointment-modal-layer-16" />
                  ) : (
                    <div className="phone-appointment-modal-layer-18" />
                  )}
                  {item.label}
                </div>
              ))}
            </div>

            <div
              className="phone-appointment-modal-layer-23"
              data-name="*选择您的设备，点击“预约”代表您同意我 们向您的手机号发送短信通知或以手机号参与 活动"
              data-text="*选择您的设备，点击“预约”代表您同意我
们向您的手机号发送短信通知或以手机号参与
活动"
            >
              *选择您的设备，点击“预约”代表您同意我们向您的手机号发送短信通知或以手机号参与活动
              {/* *选择您的设备，点击“预约”代表您同意我 们向您的手机号发送短信通知或以手机号参与 活动 */}
            </div>
            <div className="phone-appointment-modal-layer-24" onClick={() => store.appointmentByMiniprogram()} />
            {/* 预约按钮 */}
            <div className="phone-appointment-modal-layer-25" onClick={() => store.appointment()} />
            <Link
              className="phone-appointment-modal-layer-26"
              onClick={() => {
                store.onClickClose();
                onClose();
              }}
            />
          </div>
        </div>
      </div>
    </ModalContainer>
  );
};

export default wrapStore(PhoneAppointmentModal, PhoneAppointmentModalStore);
